const Button = ({ children, startIcon, endIcon, className = "", ...props }) => {
  return (
    <button {...props} className={`CT-button ${className}`}>
      {startIcon && startIcon}
      {children}
      {endIcon && endIcon}
    </button>
  );
};

export default Button;
